import type {ConferenceApiModel} from '../../../api/conference';
import type {Nullable} from '../../utility-types';

import {isConferenceCreatedByClient} from './isConferenceCreatedBy';

export const isIntroCall = (conference?: Nullable<ConferenceApiModel>) =>
  conference?.course_id === null && isConferenceCreatedByClient(conference);
